import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useOptionalAtom } from '@root/shared/lib'
import { mediaMinTablet } from '@root/shared/ui-kit'

import type { CurrencySafetyCheck } from '@root/features/premium/check-currency/atoms'
import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  result: CurrencySafetyCheck | undefined
  onBuyBoosters: () => void
  onBuySubscription: () => void
} & ClassNameProps

export const CheckCurrencyActions: React.FC<Props> = ({
  result,
  onBuyBoosters,
  onBuySubscription,
  className,
}) => {
  const { t } = useTranslation()

  const premium = useOptionalAtom(result?.premiumInfo?.premium)

  const buyBoostersDisabled =
    !result || !result.hasPassedSecurityChecks || !premium

  return (
    <Root className={className}>
      <ButtonAlt
        variant="glass"
        radius="rounded"
        color="acid"
        size="m"
        disabled={buyBoostersDisabled}
        onClick={onBuyBoosters}
      >
        {t('premium.button.buy-boosters')}
      </ButtonAlt>
      <ButtonAlt
        variant="glass"
        size="m"
        radius="rounded"
        color="premium"
        disabled={!result || !result.hasPassedSecurityChecks || premium}
        onClick={onBuySubscription}
      >
        {t('premium.button.buy-subscription')}
      </ButtonAlt>
    </Root>
  )
}

const Root = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  position: relative;

  padding-block: 0 var(--safe-bottom);
  padding-inline: 12px;

  ${mediaMinTablet(css`
    padding: 0;
  `)}
`

const ButtonAlt = styled(Button)`
  text-transform: uppercase;
  padding-inline: 0;
`
